<template>
 
       <fragment>             
                               
                                <th>Gxptest</th>
                                <th>Gxpdate</th>
                                <th>Gxpres</th>
                            
                              
        </fragment>                     
                    
                  
</template>

<script>



export default {
  name: 'Header',
  data () {
    return {
    }
  },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

     
</style>
